"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdCallToActionTypeToJSON = exports.AdCallToActionTypeFromJSONTyped = exports.AdCallToActionTypeFromJSON = exports.AdCallToActionType = void 0;
/**
 * The identifier used for the call-to-action button. This will be translated using the locale.
 * @export
 */
exports.AdCallToActionType = {
    ApplyNow: 'APPLY_NOW',
    BookNow: 'BOOK_NOW',
    BuyNow: 'BUY_NOW',
    BuyTickets: 'BUY_TICKETS',
    ClickNow: 'CLICK_NOW',
    Download: 'DOWNLOAD',
    FindStores: 'FIND_STORES',
    GetCoupon: 'GET_COUPON',
    GetInfo: 'GET_INFO',
    LearnMore: 'LEARN_MORE',
    ListenNow: 'LISTEN_NOW',
    MoreInfo: 'MORE_INFO',
    PreSave: 'PRE_SAVE',
    SaveNow: 'SAVE_NOW',
    Share: 'SHARE',
    ShopNow: 'SHOP_NOW',
    SignUp: 'SIGN_UP',
    VisitProfile: 'VISIT_PROFILE',
    VisitSite: 'VISIT_SITE',
    WatchNow: 'WATCH_NOW'
};
function AdCallToActionTypeFromJSON(json) {
    return AdCallToActionTypeFromJSONTyped(json, false);
}
exports.AdCallToActionTypeFromJSON = AdCallToActionTypeFromJSON;
function AdCallToActionTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.AdCallToActionTypeFromJSONTyped = AdCallToActionTypeFromJSONTyped;
function AdCallToActionTypeToJSON(value) {
    return value;
}
exports.AdCallToActionTypeToJSON = AdCallToActionTypeToJSON;
